import Component from '../core/Component'
import support from '../utils/BrowserSupport'

const STATES = {
    ACTIVE: 'is-active',
    VISIBLE: 'is-visible'
}

export default class Languages extends Component {

    prepare() {
        this.element.addEventListener('mouseenter', this.handleMouseEnter)
        this.element.addEventListener('mouseleave', this.handleMouseLeave)
        this.element.addEventListener(support.transitionEnd, () => {
            if (!this.is(STATES.ACTIVE)) {
                this.element.classList.remove(STATES.VISIBLE)
            }
        })
    }

    handleMouseEnter = () => {
        this.element.classList.add(STATES.VISIBLE)
        this.element.classList.offsetWidth
        this.element.classList.add(STATES.ACTIVE)
    }


    handleMouseLeave = () => {
        this.element.classList.remove(STATES.ACTIVE)
    }

}